export default __webpack_public_path__ + "static/media/bank-sms.cc51a57c.png";